import constants from '../constants';

const { SEO_FLAG_PAIRS } = constants;

const applyResolvedSeoValues = (values, canonicalUrlContext) => {
  const nextValues = { ...values };

  Object.entries(SEO_FLAG_PAIRS).forEach(([flagName, { valueField, derive }]) => {
    if (nextValues[flagName]) {
      nextValues[valueField] = derive(nextValues, canonicalUrlContext) ?? '';
    }
  });

  return nextValues;
};

export default applyResolvedSeoValues;
